import { useHttp } from '@/api'
import { httpApi } from '@/api/api'
import { clearAuth, getRefreshToken, setAuth } from './token'

// eslint-disable-next-line no-unused-vars
export function refreshAuthLogic(_responseError) {
  return new Promise((resolve, reject) => {
    const refToken = getRefreshToken()
    if (refToken) {
      // clearAuth()
      const http = useHttp()
      http
        .request(httpApi.GetToken, refToken, {
          isSkipRequestCatchHook: true,
          errCallback: () => {
            reject('refresh token failed, please login again!')
          }
        })
        .then(result => {
          setAuth(result)
          resolve()
        })
        .catch(() => {
          clearAuth()
          reject('refresh token failed, please login again!')
        })
    } else {
      clearAuth()
      reject('refresh token does not exist, please login again!')
    }
  })
}
